import CallCenterForm from './_form'
import template from './new.pug'

export default Vue.extend({
  template: template(),
  components: {
    CallCenterForm
  },
  data() {
    return {
      lastPath: null,
      lastPathParams: {},
      errors: {}
    }
  },
  beforeRouteEnter(_to, from, next) {
    // se añade el nombre de la ultima dirección, ya que, el boton cancelar debe redirigir
    // a la ultima dirección si esta es el listado de operadores o la creación de operadores
    next(vm => {
      if (['operators-index', 'operators-new', 'operators-edit'].includes(from?.name)) {
        vm.lastPathParams = from.params
        vm.lastPath = from.name
      }
    })
  },
  created() {
    this.$setPageTitle(this.$t('targetNumbers.new.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.targetNumbers.index'), route: {name: 'target-numbers-index'}},
      {label: this.$t('breadcrumbs.targetNumbers.new'), route: {}}
    ])
  },
  methods: {
    createCallCenter(data) {
      API.targetNumbers.create(data).then(() => {
        this.$notifications.success(this.$t('targetNumbers.new.succesfullyCreated'))

        this.$router.push({
          name: this.lastPath || 'target-numbers-index',
          params: this.lastPathParams
        })
      }, errors => {
        this.errors = errors
      })
    }
  }
})
